export default "__VITE_ASSET__DquhAAUv__"